import { BLACK_100, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getReviewWidgetStyles = () => {
  return StyleSheet.create({
    divider: {
      marginTop: tokens.spacing.SPACING_20
    },
    heading: {
      marginTop: tokens.spacing.SPACING_8
    },
    subHeading: {
      marginTop: tokens.spacing.SPACING_4
    },
    description: {
      marginTop: tokens.spacing.SPACING_12
    },
    toggleButton: {
      marginTop: tokens.spacing.SPACING_4,
      justifyContent: 'flex-start'
    },
    bottomCta: {
      marginTop: tokens.spacing.SPACING_20
    },
    likeDislikeContainer: {
      marginTop: tokens.spacing.SPACING_20
    },
    likeDislikeIcons: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: tokens.spacing.SPACING_8
    },
    horizontalSpace: {
      marginLeft: tokens.spacing.SPACING_8
    },
    infoContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: tokens.spacing.SPACING_12
    },
    infoIcon: {
      marginRight: tokens.spacing.SPACING_4
    },
    infoTagWidgetContainer: {
      marginTop: tokens.spacing.SPACING_20
    },
    thumbnailContaner: {
      alignItems: 'center',
      paddingTop: tokens.spacing.SPACING_20
    },
    thumbnailRightSpacing: {
      marginRight: tokens.spacing.SPACING_8
    },
    thumbnailImage: {
      backgroundColor: BLACK_100,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16
    },
    thumbnailText: {
      marginTop: tokens.spacing.SPACING_4
    },
    mainTitleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    titleTooltipInfoIcon: {
      marginLeft: tokens.spacing.SPACING_4
    },
    tooltip: {
      zIndex: -1
    }
  });
};